export const iconFontAwesomeCampingTarpDroplet = (
	<i className="fa-solid fa-tarp-droplet"></i>
);
